import { Route, Routes, Navigate } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";
import Home from "./page/Client/home";
import InfoClient from "./page/Client/Checkout";
import Panier from "./page/Client/Panier";
import ImageUpload from "./page/Client/UploadImagePage";
import Login from "./page/Admin/auth/login";
import PageCommand from "./page/Admin/magasin/PageCommad";
import PageImprimant from "./page/Admin/all/PageImprimant";
import PageSearchCommand from "./page/Admin/magasin/PageSearchCommand";
import PageCommandTraiteParCode from "./page/Admin/magasin/PageCommandTraiteParcode";
import PageImageToday from "./page/Admin/magasin/PageImageToday";
import PageCommandClient from "./page/Admin/magasin/CommandClientPage";
import Pagedashboard from "./page/Admin/magasin/PageDashboard";
import PageImageEvent from "./page/Admin/Events/PageImageEvent";
import HashtagsPage from "./page/Admin/magasin/HashtagsPage";
import PageDemention from "./page/Admin/all/PageDimension";
import PageParametre from "./page/Admin/magasin/PageParametre";

import EventCodePage from "./page/Client/Events/EventCodePage";
import EventUploadPage from "./page/Client/Events/EventUploadPage";
import PageCommandEventDashbord from "./page/Admin/Events/PageCommandEvent";
import TransparentImageOverBackground from "./composant/imageGallery/imageWithoutBg";
import { useEvent } from "./service/UseEvent";
import { useEffect } from "react";
import PageEvents from "./page/Admin/admin/pageEvents";
import PageUser from "./page/Admin/admin/PageUser";
import PageCategoryHashtag from "./page/Admin/all/categoryHashtag";
import CameraPageBox from "./page/Admin/Box/CameraPageBox";
import InformationProduct from "./page/Client/InformationProduct";
import ScrollToTop from "./service/Scroole";
import PageProduits from "./page/Admin/admin/pageProduits";
import Page404 from "./page/Client/NotFound";
import PhotoPage from "./page/Admin/Events/PageTakePhoto";
//import PageReduction from "./page/Admin/magasin/PageReduction";

const privateRoutes = [
  { path: "/admin", element: <Pagedashboard />, roles: ["gerant", "admin"] },
  {
    path: "/admin/command",
    element: <PageCommand />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/imprimant",
    element: <PageImprimant />,
    roles: ["gerant"],
  },
  {
    path: "/admin/Dimension",
    element: <PageDemention />,
    roles: ["gerant"],
  },
  {
    path: "/admin/searchCommand",
    element: <PageSearchCommand />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/imageTraite/:id",
    element: <PageCommandTraiteParCode />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/ImageTodayPage/",
    element: <PageImageToday />,
    roles: ["gerant", "staff"],
  },
  {
    path: "/admin/CommandClientPage/:id",
    element: <PageCommandClient />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/hashtags",
    element: <HashtagsPage />,
    roles: ["gerant"],
  },
  {
    path: "/admin/Parametre",
    element: <PageParametre />,
    roles: ["gerant"],
  },
  {
    path: "/admin/takeImage",
    element: <PhotoPage />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/Event",
    element: <PageCommandEventDashbord />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/imagesEvent",
    element: <PageImageEvent />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/imagesEvent",
    element: <PageImageEvent />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/categoryHashtag",
    element: <PageCategoryHashtag />,
    roles: ["gerant"],
  },
  { path: "/admin/events", element: <PageEvents />, roles: ["admin"] },
  { path: "/admin/users", element: <PageUser />, roles: ["admin"] },
  { path: "/admin/produits", element: <PageProduits />, roles: ["admin"] },
  {
    path: "/admin/CameraBox",
    element: <CameraPageBox />,
    roles: ["gerant"],
  },

  //  { path: "/admin/reduction", element: <PageReduction />, roles: ["gerant"] },
];

function IndexRoute() {
  const { IsAuth, user } = useSelector((state) => state.Auth);
  const role = user?.Role ?? ""; // ← حماية ضد undefined
  const { isEvent } = useEvent();
  useEffect(() => {
    console.log("isEvent:", isEvent);
  }, [isEvent]);

  return (
    <BrowserRouter >
      <CssBaseline />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/produit/:type" element={<ImageUpload />} />
        <Route path="/panier" element={<Panier />} />
        <Route path="/commande/:type" element={<InfoClient />} />
        <Route
          path="/InformationProduct/:type"
          element={<InformationProduct />}
        />

        <Route path="/Box" element={<CameraPageBox />} />
        <Route path="/images" element={<TransparentImageOverBackground />} />
        <Route
          path="/EventCodePage"
          element={isEvent ? <Navigate to="/event" /> : <EventCodePage />}
        />
        <Route
          path="/event"
          element={
            isEvent ? <EventUploadPage /> : <Navigate to="/EventCodePage" />
          }
        />
        <Route
          path="/login"
          element={IsAuth ? <Navigate to="/admin/command" /> : <Login />}
        />
        {privateRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              IsAuth && route.roles.includes(role) ? (
                route.element
              ) : (
                <Navigate state={{ from: route.path }} to="/login" />
              )
            }
          />
        ))}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default IndexRoute;
